<template>
    <Container>
        <div class="w-full flex my-4 gap-3">
            <Link
                href="/backstage/topics/create"
                class="text-nomad-accent rounded-md py-2 px-3 bg-nomad-700 hover:bg-nomad-600"
                >Create</Link
            >
            <Link
                href="/backstage"
                class="text-white rounded-md py-2 px-3 bg-nomad-900 hover:bg-nomad-800"
                >Cancel</Link
            >
        </div>
        <div class="w-full">
            <ul v-if="topics && topics.data" class="grid gap-3">
                <li
                    v-for="topic in topics.data"
                    :key="topic.id"
                    class="p-3 bg-nomad-900 rounded-3xl text-white"
                >
                    <Link :href="'/backstage/topics/' + topic.id + '/edit'">
                        <h2 class="text-xl text-nomad-200">
                            {{ topic.name }}
                        </h2>
                        <span class="text-nomad-600 mr-2">{{ topic.updated_at }}</span>
                    </Link>
                </li>
            </ul>
        </div>
    </Container>
</template>
<script setup>
import Container from "@/Pages/Backstage/Container.vue";
import { Link, usePage } from "@inertiajs/vue3";
const { topics } = usePage().props;
</script>